module.exports = __webpack_public_path__ + "static/media/oracle.c9eee1ac.png";